import React from 'react';
import { IsStringEmpty } from '../../../utilities/CommonMethods';

import classes from './CircularProgressBar.module.css';

const CircularProgressBar = (props) => {
    return (
        <div className={classes.CircularProgressBarSection}>
            <div className={classes.CircularProgressBarContainer}>
                <div className={classes.CircularProgressBar}>
                    <svg viewBox="0 0 36 36" width={!IsStringEmpty(props.width) ? props.width : ''}>
                        <path className={classes.PathBack}
                            d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                        <path className={[classes.PathFront, !IsStringEmpty(props.styleclass) ? classes[props.styleclass] : ''].join(' ')} style={{ strokeDasharray: `${props.progress}, 100` }}
                            d="M18 2.0845a 15.9155 15.9155 0 0 1 0 31.831 a 15.9155 15.9155 0 0 1 0 -31.831" />
                    </svg>
                    {
                        props.type === 'percentage'
                            ? <p className={[classes.Progress, !IsStringEmpty(props.textStyle) ? props.textStyle : ''].join(' ')}>{props.progress}<span>%</span></p>
                            : props.type === 'fraction'
                                ? <p className={[classes.Progress, !IsStringEmpty(props.textStyle) ? props.textStyle : ''].join(' ')}>{props.value[0]}<span>/{props.value[1]}</span></p>
                                : <p className={[classes.Progress, !IsStringEmpty(props.textStyle) ? props.textStyle : ''].join(' ')}>{props.value}</p>
                    }


                </div>
            </div>
            {props.showProgressText
                ? <div className={classes.ProgressText}><span>{props.progressText}</span></div>
                : null}
        </div>
    );
}

export default CircularProgressBar;
